@if (titles.length > 1) {
  <div>
    <div class="block">
      <div class="border-b border-edge">
        <nav class="-mb-px flex gap-8">
          @for (title of titles; track title; let i = $index) {
            @if (i === activeTab) {
              <div
                class="whitespace-nowrap py-4 px-1 border-b-2 border-primary font-medium text-sm leading-5 text-primary focus:outline-none focus:text-blue-800 focus:border-blue-700"
                aria-current="page"
                [innerHTML]="title"
              ></div>
            } @else {
              <a
                (click)="activateTab(i)"
                [innerHTML]="title"
                class="whitespace-nowrap py-4 px-1 border-b-2 border-transparent font-medium text-sm leading-5 text-fg-secondary hover:text-fg-subtle hover:border-edge-strong hover:cursor-pointer focus:outline-none focus:text-fg-subtle focus:border-edge-strong"
              >
              </a>
            }
          }
        </nav>
      </div>
    </div>
  </div>
}

<div class="min-h-0 flex-1">
  <!-- using an ng-container allows us to render the template without any additional wrapping -->
  <ng-container [ngTemplateOutlet]="templates[activeTab]"></ng-container>
</div>
